import { defineStore } from 'pinia'
import axios from '@/services/index.js'

export const useBranchofficesStore = defineStore('branchoffices', {
  modelName: 'Branchoffice',
  state: () => ({
    loading: false,
    branchoffices: [],
    selectedBranchofficeId: "",
    // Datos específicos de la sucursal actual del usuario
    current: {
      id: null,
      name: '',
      business_name: '',
      cuit: '',
      address: '',
      phone: '',
      configs: {
        id: null,
        pricelist_id: null,
        client_id: null,
        fund_id: null,
        pos_id: null,
        warehouse_id: null,
        bo_id: null,
      },
      options: {
        salesclerk_module: 0
      },
      payments_methods: {
        id: null,
        bo_id: null,
        efectivo: 1,
        cuenta_corriente: 1,
        cheques: 1,
        tarjetas: 1,
      }
    }
  }),

  getters: {
    // Getter para sucursal actual - siempre retorna objeto válido
    getCurrentBranchoffice: (state) => {
      return state.current || {}
    },
    
    // Getters específicos para datos comunes
    currentConfigs: (state) => {
      return state.current?.configs || {}
    },
    
    currentOptions: (state) => {
      return state.current?.options || {}
    },
    
    currentPaymentMethods: (state) => {
      return state.current?.payments_methods || {}
    },
    
    // Getter para salesclerk module
    salesclerkModule: (state) => {
      return state.current?.options?.salesclerk_module || 0
    },
    
    // Getter para payment method CC
    paymentMethodCC: (state) => {
      return state.current?.payments_methods?.cuenta_corriente || 1
    },
    
    // Verificar si la sucursal está cargada
    isCurrentLoaded: (state) => {
      return state.current && state.current.id !== null
    },

    // Getters adicionales
    getAllBranchoffices: (state) => state.branchoffices,
    getSelectedBranchofficeId: (state) => state.selectedBranchofficeId,
    isLoading: (state) => state.loading
  },

  actions: {
    onModelChanged() {
      this.fetchAllBranchoffices()
    },

    async fetchAllBranchoffices() {
      try {
        const response = await axios.get('/api/branchoffices/getBranchoffices')
        this.branchoffices = response.data.data
        return response.data.data
      } catch (error) {
        console.error('Error fetching branchoffices:', error)
        this.branchoffices = []
        throw error
      }
    },

    readSelectedBranchofficeId() {
      let localId = localStorage.getItem('branchofficeId')
      localId = localId == undefined ? "" : localId
      this.selectedBranchofficeId = localId
    },

    setSelectedBranchofficeId(selectedBranchofficeId) {
      localStorage.branchofficeId = selectedBranchofficeId
      this.selectedBranchofficeId = selectedBranchofficeId
    },
    
    // Establecer sucursal actual desde respuesta de API
    setCurrentBranchoffice(branchofficeData) {
      this.current = {
        ...this.current,
        ...branchofficeData,
        configs: { ...this.current.configs, ...(branchofficeData.configs || {}) },
        options: { ...this.current.options, ...(branchofficeData.options || {}) },
        payments_methods: { ...this.current.payments_methods, ...(branchofficeData.payments_methods || branchofficeData.paymentsMethods || {}) }
      }
    },
    
    // Limpiar datos de sucursal actual
    clearCurrentBranchoffice() {
      this.current = {
        id: null,
        name: '',
        business_name: '',
        cuit: '',
        address: '',
        phone: '',
        configs: {
          id: null,
          pricelist_id: null,
          client_id: null,
          product_id: null,
          fund_id: null,
          pos_id: null,
          warehouse_id: null,
          bo_id: null,
        },
        options: {
          salesclerk_module: 0
        },
        payments_methods: {
          id: null,
          bo_id: null,
          efectivo: 1,
          cuenta_corriente: 1,
          cheques: 1,
          tarjetas: 1,
        }
      }
    },

    async getLoading() {
      this.loading = true
      try {
        await new Promise(resolve => setTimeout(resolve, 1000))
      } catch (error) {
        // Handle error if needed
      } finally {
        this.loading = false
      }
    },

    setLoading(value) {
      this.loading = value
    },

    async fetchMercadoPagoQRs(token) {
      this.loading = true
      try {
        const response = await axios.get(`/api/configs/fetchqrs/${token}`)
        return response.data.data
      } catch (error) {
        console.error('Error fetching MercadoPago QRs:', error)
        throw error
      } finally {
        this.loading = false
      }
    }
  }
})